import Button from "@/components/button/Button"
import { useGlobalContext } from "@/components/context/GlobalContext"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useResendEmailConfirmationOnLoginMutation } from "@/graphql"
import { Col, message, Row } from "antd"
import { FC } from "react"
import { useParams } from "react-router-dom"
import "./EmailTaken.less"

const { Title, Paragraph } = WebsiteTypography

const EmailTaken: FC = () => {
  const { loginEmail } = useGlobalContext()
  const { setModalDarkTypes } = useModalDarkContext()
  const { org } = useParams()
  const [resendEmailConfirmation, { loading: emailResending }] = useResendEmailConfirmationOnLoginMutation()

  return (
    <Row justify={"center"} className={"email-not-confirmed-wrapper"} style={{ paddingTop: 24, paddingBottom: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Title level={3} centered className={"section-title"} style={{ paddingBottom: 24 }}>
          <span className={"w300"}>{"Email Already "}</span>
          <span className={"bold"}>{"Registered"}</span>
        </Title>

        <Row justify={"center"}>
          <div className={"hex-wrapper"}>
            <SvgIcon type={"envelope-with-lock"} />
          </div>
        </Row>

        <Row justify={"center"}>
          <Col span={24}>
            <Paragraph
              centered
              size={"md"}
              style={{ paddingTop: 24, paddingBottom: 24 }}
              color={"website-secondary"}
              weight={"w300"}
            >
              {
                "The email address you entered is already registered in our system. If you already have an account, please sign in using your existing credentials. If you've forgotten your password, use the Forgot Password option to regain access."
              }
            </Paragraph>
          </Col>
        </Row>
      </Col>

      <Row justify={"center"} className={"divider-with-hex"} style={{ margin: "0 0 24px 0" }}>
        <div className={"hex-small"} />
      </Row>

      <Row justify={"center"}>
        <Paragraph weight={"w300"} size={"sm"} color={"website-secondary"} centered>
          {"If you believe this is an error, please contact your administrator or support team for assistance."}
        </Paragraph>
      </Row>
    </Row>
  )
}

export default EmailTaken
